import React from 'react';
import {
  MarqueeSection,
  MarqueeContainer,
  MarqueeWrapper,
  MarqueeContent,
  MarqueeText,
} from './Marquee.styled';

const MarqueeTextComponent = () => {
  // Create multiple instances for seamless marquee
  const text = 'SECURE. STABLE. SWAN. ';
  const marqueeInstances = Array(15).fill(text);
  return (
    <MarqueeSection
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <MarqueeContainer>
        <MarqueeWrapper>
          <MarqueeContent>
            {marqueeInstances.map((text, index) => (
              <MarqueeText key={index}>{text}</MarqueeText>
            ))}
          </MarqueeContent>
        </MarqueeWrapper>
      </MarqueeContainer>
    </MarqueeSection>
  );
};

export default MarqueeTextComponent;
